var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMore(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 18,
    viewBox: "0 0 23 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.8841 14.3763H9.82434V15.6882H12.8841V14.3763Z",
    stroke: "white",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.7598 15.6882H8.95212C8.71987 15.6882 8.49713 15.7804 8.3329 15.9447C8.16868 16.1089 8.07642 16.3316 8.07642 16.5639V17H14.6355V16.5639C14.6355 16.3316 14.5432 16.1089 14.379 15.9447C14.2148 15.7804 13.9921 15.6882 13.7598 15.6882V15.6882Z",
    stroke: "white",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.2592 14.3764H5.45281C5.10489 14.3764 4.77123 14.2382 4.52521 13.9921C4.2792 13.7461 4.14099 13.4125 4.14099 13.0646V12.1888H18.578V13.0646C18.578 13.2374 18.5438 13.4086 18.4775 13.5682C18.4111 13.7278 18.3138 13.8727 18.1913 13.9946C18.0687 14.1165 17.9233 14.213 17.7633 14.2785C17.6034 14.344 17.432 14.3773 17.2592 14.3764V14.3764Z",
    stroke: "white",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M13.6062 3.44922H8.80554",
    stroke: "white",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M18.571 9V12.1923H4.14099V9.79197",
    stroke: "white",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M7.67523 3.44922L8.64165 7.04276C8.66822 7.14546 8.65303 7.2545 8.59942 7.34604C8.54581 7.43757 8.45813 7.50415 8.35556 7.53121L4.14099 8.65811",
    stroke: "white",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M14.7401 3.44922L13.9935 6.24032C13.9797 6.28935 13.9757 6.34061 13.9817 6.39118C13.9878 6.44175 14.0037 6.49064 14.0287 6.53504C14.0536 6.57944 14.0871 6.61847 14.1272 6.64992C14.1672 6.68137 14.2131 6.7046 14.2621 6.7183L18.5779 7.87312",
    stroke: "white",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M11.356 13.5042C11.4774 13.5042 11.5758 13.4058 11.5758 13.2844C11.5758 13.163 11.4774 13.0646 11.356 13.0646C11.2346 13.0646 11.1362 13.163 11.1362 13.2844C11.1362 13.4058 11.2346 13.5042 11.356 13.5042Z",
    stroke: "white",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M8.35553 7.53118L4.14097 8.65809L3.16408 8.92324C3.1123 8.93627 3.05846 8.93893 3.00565 8.93105C2.95284 8.92318 2.90211 8.90494 2.85638 8.87737C2.81066 8.84981 2.77084 8.81346 2.73922 8.77044C2.7076 8.72741 2.6848 8.67856 2.67215 8.62669L1.01493 2.45138C1.00065 2.40075 0.99656 2.34779 1.00289 2.29557C1.00922 2.24335 1.02584 2.1929 1.0518 2.14715C1.07776 2.10139 1.11254 2.06125 1.15412 2.02903C1.1957 1.99681 1.24326 1.97316 1.29404 1.95944L4.89108 1L5.42139 2.98866L7.41354 2.45486L7.68218 3.44919L8.6486 7.04274C8.66164 7.09406 8.6644 7.14745 8.6567 7.19984C8.64901 7.25223 8.63103 7.30259 8.60378 7.34799C8.57654 7.3934 8.54058 7.43296 8.49797 7.4644C8.45536 7.49584 8.40695 7.51854 8.35553 7.53118V7.53118Z",
    stroke: "white",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M7.40659 2.45486L5.42491 2.98866L4.89111 1L7.40659 2.45486Z",
    stroke: "white",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M7.40659 2.45486L5.42491 2.98866L4.89111 1L7.40659 2.45486Z",
    stroke: "white",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M2.43835 3.78758L4.42702 3.25378",
    stroke: "white",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M2.70361 4.78195L6.51696 3.7597",
    stroke: "white",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M2.97217 5.77627L6.78202 4.75403",
    stroke: "white",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M3.2373 6.77059L7.05065 5.74835",
    stroke: "white",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M22.1854 4.03882L21.0829 8.14174C21.0567 8.24055 20.9924 8.32497 20.9042 8.37661C20.816 8.42824 20.7109 8.44289 20.6119 8.41736L18.5779 7.8731L14.2621 6.71828C14.2131 6.70459 14.1672 6.68135 14.1272 6.6499C14.0871 6.61846 14.0536 6.57942 14.0287 6.53502C14.0037 6.49062 13.9878 6.44174 13.9817 6.39117C13.9757 6.34059 13.9797 6.28933 13.9935 6.24031L14.7401 3.4492L15.2914 1.38727C15.3043 1.33849 15.3268 1.29276 15.3575 1.25275C15.3883 1.21275 15.4267 1.17927 15.4706 1.15426C15.5144 1.12926 15.5628 1.11323 15.6129 1.10711C15.663 1.101 15.7138 1.10491 15.7624 1.11863L16.8858 1.41518L17.4335 2.36416L21.9098 3.56433C21.9593 3.57688 22.0059 3.5992 22.0467 3.62999C22.0875 3.66077 22.1217 3.6994 22.1474 3.7436C22.1731 3.7878 22.1897 3.83668 22.1962 3.88737C22.2027 3.93807 22.199 3.98956 22.1854 4.03882V4.03882Z",
    stroke: "white",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMore);
export default __webpack_public_path__ + "static/media/more.b980d5a5cc6d0ae7050e2e65dad42389.svg";
export { ForwardRef as ReactComponent };